<template>
  <div class="absolute top-0 h-full w-full">
    <img
      class="absolute top-0 h-full w-full"
      src="/images/wrapped/bgpage01.jpg"
      alt=""
    />
    <img
      class="absolute -top-[2px]"
      src="/images/wrapped/gradient.png"
      alt=""
    />
    <img
      class="absolute left-4 top-8 h-auto max-h-[21px] w-auto max-w-[21px]"
      src="/images/wrapped/ddccircularlogo.png"
      alt=""
    />
    <img
      class="absolute -bottom-1 w-full"
      src="/images/wrapped/footerillustration.png"
      alt=""
    />Í
    <div
      class="absolute top-[35%] flex w-full flex-col items-center justify-center text-center"
    >
      <WrappedTextContainer
        class="whitespace-nowrap text-[36px] leading-none text-white"
      >
        Your top cause{{ campaigns.length > 1 ? "s" : "" }}
        {{ campaigns.length > 1 ? "were" : "was" }}
      </WrappedTextContainer>
      <div
        v-for="(item, index) in campaigns"
        :key="index"
        class="mt-2 flex space-x-1"
      >
        <WrappedShadowContainer
          class="relative flex h-11 w-[64px] items-center px-3"
          :class="item.color"
        >
          <WrappedTextContainer class="w-fit text-[30px] font-bold text-white">
            #{{ index + 1 }}
          </WrappedTextContainer>
        </WrappedShadowContainer>
        <WrappedShadowContainer
          class="relative flex max-h-fit min-h-11 min-w-[250px] max-w-fit items-center gap-1 bg-[#61E5FF] px-1"
          :class="item.color"
        >
          <img
            class="h-8 w-8 rounded-lg border-[1px] border-solid border-[#16114F]"
            :src="item.image"
            alt=""
          />
          <WrappedTextContainer class="align-middle text-[30px] text-white">
            {{ item.name }}
          </WrappedTextContainer>
        </WrappedShadowContainer>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Campaign } from "~/lib/campaigns";

interface WrappedData {
  campaignId: Campaign;
  impactValue: number;
  totalAmount: number;
}

const props = defineProps<{
  wrappeddata: Array<WrappedData>;
}>();

const campaigns = computed(() =>
  props.wrappeddata.map((item) => ({
    name: campaignName(item.campaignId),
    image: campaignImage(item.campaignId),
    color: campaignColors(item.campaignId),
  })),
);

function campaignName(campaignId: number) {
  if (campaignId == Campaign.TFTF) {
    return "Reforestation";
  } else if (campaignId == Campaign.SARTHAK) {
    return "Education";
  } else if (campaignId == Campaign.PF) {
    return "Ocean Cleanup";
  } else {
    return "Ocean Cleanup";
  }
}

function campaignImage(campaignId: number) {
  if (campaignId == Campaign.TFTF) {
    return "/images/wrapped/tree.png";
  } else if (campaignId == Campaign.SARTHAK) {
    return "/images/wrapped/book.png";
  } else if (campaignId == Campaign.PF) {
    return "/images/wrapped/dolphin.png";
  } else {
    return "/images/wrapped/turtle.png";
  }
}

function campaignColors(campaignId: number) {
  if (campaignId === Campaign.TFTF) {
    return "bg-[#D7EB61]";
  } else if (campaignId === Campaign.PF) {
    return "bg-[#61E5FF]";
  } else if (campaignId === Campaign.SARTHAK) {
    return "bg-[#FFE617]";
  }
}
</script>
